export default __webpack_public_path__ + "static/media/14.d1a9679b.jpg";